/**
 * Cuando una petición con Bearer recibe 401, se notifica al modal global.
 */

const listeners = new Set();

let alreadyEmitted = false;

export function subscribeSessionExpired(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function emitSessionExpired() {
  if (alreadyEmitted) return;
  alreadyEmitted = true;
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* noop */
    }
  });
}

export function resetSessionExpiredEmitter() {
  alreadyEmitted = false;
}
